import Config from "services/config/config";
import callWebService, {
  callTypes
} from "services/utils/networks/network";
import { 
  CREATE_TICKET, 
  SEARCH_USER, 
  USER_ROLE_DROPDOWN, 
  SAVE_EXTERNAL_USER, 
  EXTERNAL_USER_LIST 
} from "./type";

export const createTicket = (obj) => async (dispatch) => {
  const newObj = {
    "subject": obj.subject,
    "description": obj.summary,
    "attatchment": obj.document,
    "user_data": [
      {
        "user_id": obj.userId
      }
    ]
  }
  try {
    const res = await callWebService(
      callTypes.post,
      newObj,
      `${Config.tickets.createTicket}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: CREATE_TICKET,
        payload: data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: CREATE_TICKET,
      payload: null,
    });
    return true;
  }
};

export const getSearchUser = (user, options = {}) => async (dispatch) => {
  try {
    const params = new URLSearchParams();
    const name = user != null ? String(user).trim() : '';
    if (name) {
      params.set('name', name);
    }
    if (options?.searchEmail) {
      params.set('search_email', '1');
    }
    if (options?.teamId) {
      params.set('team_id', String(options.teamId));
    }
    const qs = params.toString();
    const url = qs
      ? `${Config.tickets.getSearchUser}?${qs}`
      : Config.tickets.getSearchUser;
    const res = await callWebService(
        callTypes.get,
        "",
        url
      );
  
      if (res) {
        const { data } = res;
        const list = data?.response?.data ?? data?.data ?? [];
        dispatch({
          type: SEARCH_USER,
          payload: list,
        });
        return list;
      }
  }
  catch {
    dispatch({
      type: SEARCH_USER,
      payload: [],
    });
    return [];
  }
}

// Unused: Select User UI that consumed getUserBasedDropdown is commented out in commercialNew.
export const userRoleBasedDropdown = (id, leadId) => async (dispatch) => {
  // const res = await callWebService(
  //   callTypes.get,
  //   '',
  //   `${Config.tickets.userRoleDropdown}?lead_type_id=${id}&lead_id=${leadId}`
  // );
  // if (res) {
  //   const { data } = res;
  //   dispatch({
  //     type: USER_ROLE_DROPDOWN,
  //     payload: data.response.data,
  //   });
  //   return true;
  // }
  return true;
};

export const saveExternalUserData = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.tickets.saveExternalUser}`
  );
  if (res) {
      const { data } = res;
      dispatch({
          type: SAVE_EXTERNAL_USER,
          payload: data.response,
      });
      return true;
  }
};

export const getExternalUsersList = (leadId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.tickets.externalUsersList}?lead_id=${leadId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: EXTERNAL_USER_LIST,
      payload: data.response.data,
    });
    return true;
  }
};